// 0026: Generic grid of gallery tiles. Receives an array of nodes plus the generic
// accessors so it is agnostic to whether the nodes are Categories or ItemGroups (or,
// in a future deep tree, anything else). Click handling is delegated to the parent.
import CategoryGalleryTile from "./CategoryGalleryTile";
import { getNodeId, getNodeName, getNodeImage } from "../../../utils/categories/categoryTree";
import "../../../styles/components/categories/gallery/categoryGalleryGrid.scss";

export const CategoryGalleryGrid = ({ nodes, onNodeClick }) => {
  if (!nodes || nodes.length === 0) {
    return <div className="categoryGalleryEmpty">לא נמצאו קטגוריות להצגה</div>;
  }

  return (
    <div className="categoryGalleryGrid">
      {nodes.map((node) => (
        <CategoryGalleryTile key={getNodeId(node)} name={getNodeName(node)} imageUrl={getNodeImage(node)} onClick={() => onNodeClick?.(node)} />
      ))}
    </div>
  );
};

export default CategoryGalleryGrid;
